import { IRecruitmentCandidatesFilters, RecruitmentCandidatesFiltersModel } from "@core/models";
import { ArrayHelpers } from "@core/helpers";

export class RecruitmentCandidatesFiltersDTO extends RecruitmentCandidatesFiltersModel {
  prepareFiltersData() {
    return {
      location: this.getFilteredLocations(),
      language: this.getFilteredLanguages(),
      nb_exp: this.getFilteredExperiences(),
      has_recommendation: this.hasRecommendation() ? 1 : undefined,
      has_vehicle: this.hasVehicle() ? 1 : undefined,
      already_worked_in: this.hasAlreadyWorkedIn() ? 1 : undefined,
    };
  }

  getFilteredLocations() {
    if (this[IRecruitmentCandidatesFilters.postalCode]?.length > 0) {
      return ArrayHelpers.forceArray(this[IRecruitmentCandidatesFilters.postalCode]);
    }
    return undefined;
  }

  getFilteredExperiences() {
    if (this[IRecruitmentCandidatesFilters.workExperiences]?.length > 0) {
      return ArrayHelpers.forceArray(this[IRecruitmentCandidatesFilters.workExperiences]);
    }
    return undefined;
  }

  getFilteredLanguages() {
    if (this[IRecruitmentCandidatesFilters.languages]?.length > 0) {
      return ArrayHelpers.forceArray(this[IRecruitmentCandidatesFilters.languages]);
    }
    return undefined;
  }
}
